import { default as altes_45dashboardzwvTZbzV3eMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/altes-dashboard.vue?macro=true";
import { default as indexDDijidUO9UMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/auth/index.vue?macro=true";
import { default as indexGqemCvM8ukMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as indexFSUbINKCchMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/index.vue?macro=true";
import { default as organisationBaseDataQorYbRrs1lMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as _91id_93mpv0w9eYZ3Meta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations/[id].vue?macro=true";
import { default as indexvQHTSLgvwOMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations/index.vue?macro=true";
import { default as organisationsxpi54hgyeUMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations.vue?macro=true";
import { default as dungeonN8QxdrmiXDMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputswDHfhx8UU4Meta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexUWS7mkvnRVMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/secret/index.vue?macro=true";
import { default as languageos7k0lIrl3Meta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/language.vue?macro=true";
import { default as _91id_93n7ALKFhfWUMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/loginProviders/[id].vue?macro=true";
import { default as indexCjxdBGfvWCMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/loginProviders/index.vue?macro=true";
import { default as _91_46_46_46slug_93gRNjUGpAmRMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/mailTemplates/[name]/[...slug].vue?macro=true";
import { default as indexwRDV8A6yDUMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/mailTemplates/index.vue?macro=true";
import { default as settingsEfi5F0bgN3Meta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings.vue?macro=true";
import { default as _91id_93RuTJfjApO4Meta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/bots/[id].vue?macro=true";
import { default as index02fcvdKK5OMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/bots/index.vue?macro=true";
import { default as messages8IsJjFzcExMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/messages.vue?macro=true";
import { default as orders88Dh0974CkMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/orders.vue?macro=true";
import { default as _91id_93dBEVqdy3XEMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/trading/bot/[id].vue?macro=true";
import { default as userActivitiesgjMMSI6eEjMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataq49jrOdiI0Meta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id]/userBaseData.vue?macro=true";
import { default as userCommunicationsb1MPpzdrfDMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id]/userCommunications.vue?macro=true";
import { default as _91id_93FD30n3hdsuMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id].vue?macro=true";
import { default as indexLa7EWsYzgGMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/index.vue?macro=true";
import { default as users5XonNqnOoVMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users.vue?macro=true";
import { default as _91_46_46_46slug_93HAXRBKTvWoMeta } from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/wiki/[...slug].vue?macro=true";
export default [
  {
    name: "altes-dashboard",
    path: "/altes-dashboard",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/altes-dashboard.vue").then(m => m.default || m)
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexDDijidUO9UMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexGqemCvM8ukMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/auth/social/[organisation]/[provider]/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/index.vue").then(m => m.default || m)
  },
  {
    name: organisationsxpi54hgyeUMeta?.name,
    path: "/organisations",
    meta: organisationsxpi54hgyeUMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations.vue").then(m => m.default || m),
    children: [
  {
    name: "organisations-id",
    path: ":id()",
    meta: _91id_93mpv0w9eYZ3Meta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations/[id]/organisationBaseData.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "organisations",
    path: "",
    meta: indexvQHTSLgvwOMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/organisations/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/secret/index.vue").then(m => m.default || m),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/secret/index/dungeon.vue").then(m => m.default || m)
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/secret/index/inputs.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsEfi5F0bgN3Meta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/language.vue").then(m => m.default || m)
  },
  {
    name: "settings-loginProviders-id",
    path: "loginProviders/:id()",
    meta: _91id_93n7ALKFhfWUMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/loginProviders/[id].vue").then(m => m.default || m)
  },
  {
    name: "settings-loginProviders",
    path: "loginProviders",
    meta: indexCjxdBGfvWCMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/loginProviders/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-mailTemplates-name-slug",
    path: "mailTemplates/:name()/:slug(.*)*",
    meta: _91_46_46_46slug_93gRNjUGpAmRMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/mailTemplates/[name]/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "settings-mailTemplates",
    path: "mailTemplates",
    meta: indexwRDV8A6yDUMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/settings/mailTemplates/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "telegram-bots-id",
    path: "/telegram/bots/:id()",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/bots/[id].vue").then(m => m.default || m)
  },
  {
    name: "telegram-bots",
    path: "/telegram/bots",
    meta: index02fcvdKK5OMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/bots/index.vue").then(m => m.default || m)
  },
  {
    name: "telegram-messages",
    path: "/telegram/messages",
    meta: messages8IsJjFzcExMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/messages.vue").then(m => m.default || m)
  },
  {
    name: "telegram-orders",
    path: "/telegram/orders",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/telegram/orders.vue").then(m => m.default || m)
  },
  {
    name: "trading-bot-id",
    path: "/trading/bot/:id()",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/trading/bot/[id].vue").then(m => m.default || m)
  },
  {
    name: users5XonNqnOoVMeta?.name,
    path: "/users",
    meta: users5XonNqnOoVMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users.vue").then(m => m.default || m),
    children: [
  {
    name: "users-id",
    path: ":id()",
    meta: _91id_93FD30n3hdsuMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id]/userActivities.vue").then(m => m.default || m)
  },
  {
    name: "users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDataq49jrOdiI0Meta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id]/userBaseData.vue").then(m => m.default || m)
  },
  {
    name: "users-id-userCommunications",
    path: "userCommunications",
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/[id]/userCommunications.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "users",
    path: "",
    meta: indexLa7EWsYzgGMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/users/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93HAXRBKTvWoMeta || {},
    component: () => import("/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/pages/wiki/[...slug].vue").then(m => m.default || m)
  }
]